import script from "./CopyHistoryResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyHistoryResult.vue?vue&type=script&setup=true&lang=js"

import "./CopyHistoryResult.vue?vue&type=style&index=0&id=a5d123aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5d123aa"]])

export default __exports__